import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EmbedModal from './EmbedModal';
import style from './styles/style.module.css';

class Embed extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            showModal: false,
        };
    }
    shareAndTrack = () => {
        if( this.props.trackShare ) {
            this.props.trackShare( 'embed' );
        }

        this.setState( { showModal: true } );
    }
    hideModal = () => {
        this.setState( { showModal: false } );
    }
    render() {
        return (
            <div className={ style.embedLink } style={ this.props.style }>
                <span onClick={ this.shareAndTrack }>EMBED</span>
                { this.state.showModal &&
                    <EmbedModal listid={ this.props.list.listid } onClose={ this.hideModal } />
                }
            </div>
        );
    }
}
Embed.propTypes = {
    list: PropTypes.object,
};

export default Embed;
